
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Playground } from 'docz';
import PropsTable from './docs/PropsTable';
import { COMMON } from './docs/system_props';
import { Text } from './Text';
import { Box } from './Box';
import { Button } from './Button';
import { Heading } from './Heading';
import { ModalDialog } from './ModalDialog';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "modaldialog"
    }}>{`ModalDialog`}</h1>
    <h2 {...{
      "id": "basic-example"
    }}>{`Basic example`}</h2>
    <Playground __position={0} __code={'() => {\n  const [modalIsOpen, setModalIsOpen] = React.useState(false)\n  return (\n    <>\n      {modalIsOpen && (\n        <ModalDialog onRequestClose={() => setModalIsOpen(false)}>\n          <Box>\n            <Heading as=\"h2\" variant=\"h2\" pl={8} pr={48}>\n              Modal Heading\n            </Heading>\n            <Text as=\"div\" p={8}>\n              Here is some content\n            </Text>\n          </Box>\n        </ModalDialog>\n      )}\n      <Button onClick={() => setModalIsOpen(true)}>Open Modal</Button>\n    </>\n  )\n}'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      Text,
      Box,
      Button,
      Heading,
      ModalDialog
    }} __codesandbox={`undefined`} mdxType="Playground">
  {() => {
        const [modalIsOpen, setModalIsOpen] = React.useState(false);
        return <>
        {modalIsOpen && <ModalDialog onRequestClose={() => setModalIsOpen(false)} mdxType="ModalDialog">
            <Box mdxType="Box">
              <Heading as="h2" variant="h2" pl={8} pr={48} mdxType="Heading">
                Modal Heading
              </Heading>
              <Text as="div" p={8} mdxType="Text">
                Here is some content
              </Text>
            </Box>
          </ModalDialog>}
        <Button onClick={() => setModalIsOpen(true)} mdxType="Button">Open Modal</Button>
      </>;
      }}
    </Playground>
    <h2 {...{
      "id": "hide-the-close-button"
    }}>{`Hide the close button`}</h2>
    <Playground __position={1} __code={'() => {\n  const [modalIsOpen, setModalIsOpen] = React.useState(false)\n  return (\n    <>\n      {modalIsOpen && (\n        <ModalDialog\n          onRequestClose={() => setModalIsOpen(false)}\n          showCloseButton={false}\n        >\n          <Box>\n            <Heading as=\"h2\" variant=\"h2\" pl={8} pr={48}>\n              Modal Heading\n            </Heading>\n            <Text as=\"div\" p={8}>\n              There is no close button here\n            </Text>\n          </Box>\n        </ModalDialog>\n      )}\n      <Button onClick={() => setModalIsOpen(true)}>Open Modal</Button>\n    </>\n  )\n}'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      Text,
      Box,
      Button,
      Heading,
      ModalDialog
    }} __codesandbox={`undefined`} mdxType="Playground">
  {() => {
        const [modalIsOpen, setModalIsOpen] = React.useState(false);
        return <>
        {modalIsOpen && <ModalDialog onRequestClose={() => setModalIsOpen(false)} showCloseButton={false} mdxType="ModalDialog">
            <Box mdxType="Box">
              <Heading as="h2" variant="h2" pl={8} pr={48} mdxType="Heading">
                Modal Heading
              </Heading>
              <Text as="div" p={8} mdxType="Text">
                There is no close button here
              </Text>
            </Box>
          </ModalDialog>}
        <Button onClick={() => setModalIsOpen(true)} mdxType="Button">Open Modal</Button>
      </>;
      }}
    </Playground>
    <h2 {...{
      "id": "require-confirmation-before-dialog-can-be-closed"
    }}>{`Require confirmation before dialog can be closed`}</h2>
    <Playground __position={2} __code={'() => {\n  const [modalIsOpen, setModalIsOpen] = React.useState(false)\n  return (\n    <>\n      {modalIsOpen && (\n        /* eslint-disable-next-line */\n        <ModalDialog\n          onRequestClose={() => {\n            confirm(\'Are you sure?\') ? setModalIsOpen(false) : null\n          }}\n        >\n          <Box>\n            <Heading as=\"h2\" variant=\"h2\" pl={8} pr={48}>\n              Modal Heading\n            </Heading>\n            <Text as=\"div\" p={8}>\n              Confirmation is required to close this dialog\n            </Text>\n          </Box>\n        </ModalDialog>\n      )}\n      <Button onClick={() => setModalIsOpen(true)}>Open Modal</Button>\n    </>\n  )\n}'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      Text,
      Box,
      Button,
      Heading,
      ModalDialog
    }} __codesandbox={`undefined`} mdxType="Playground">
  {() => {
        const [modalIsOpen, setModalIsOpen] = React.useState(false);
        return <>
        {modalIsOpen &&
          /* eslint-disable-next-line */
          <ModalDialog onRequestClose={() => {
            confirm('Are you sure?') ? setModalIsOpen(false) : null;
          }} mdxType="ModalDialog">
            <Box mdxType="Box">
              <Heading as="h2" variant="h2" pl={8} pr={48} mdxType="Heading">
                Modal Heading
              </Heading>
              <Text as="div" p={8} mdxType="Text">
                Confirmation is required to close this dialog
              </Text>
            </Box>
          </ModalDialog>}
        <Button onClick={() => setModalIsOpen(true)} mdxType="Button">Open Modal</Button>
      </>;
      }}
    </Playground>
    <h2 {...{
      "id": "the-args-to-onrequestclose-indicate-how-the-modal-was-closed"
    }}>{`The args to onRequestClose indicate how the modal was closed`}</h2>
    <h4 {...{
      "id": "possible-values-closebuttonwasclicked-backdropwasclicked-esckeywaspressed"
    }}>{`Possible values: closeButtonWasClicked, backdropWasClicked, escKeyWasPressed`}</h4>
    <Playground __position={3} __code={'() => {\n  const [modalIsOpen, setModalIsOpen] = React.useState(false)\n  const [onRequestCloseArgs, setOnRequestCloseArgs] = React.useState({})\n  return (\n    <>\n      {modalIsOpen && (\n        <ModalDialog\n          onRequestClose={args => {\n            setModalIsOpen(false)\n            setOnRequestCloseArgs(args)\n          }}\n        >\n          Close this modal and see below for the args to onRequestClose\n        </ModalDialog>\n      )}\n      <Button onClick={() => setModalIsOpen(true)} mb=\"m\">\n        Open Modal\n      </Button>\n      {onRequestCloseArgs && (\n        <>\n          <Heading as=\"h5\" variant=\"h5\">\n            Args\n          </Heading>\n          <div>{JSON.stringify(onRequestCloseArgs)}</div>\n        </>\n      )}\n    </>\n  )\n}'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      Text,
      Box,
      Button,
      Heading,
      ModalDialog
    }} __codesandbox={`undefined`} mdxType="Playground">
  {() => {
        const [modalIsOpen, setModalIsOpen] = React.useState(false);
        const [onRequestCloseArgs, setOnRequestCloseArgs] = React.useState({});
        return <>
        {modalIsOpen && <ModalDialog onRequestClose={args => {
            setModalIsOpen(false);
            setOnRequestCloseArgs(args);
          }} mdxType="ModalDialog">
            Close this modal and see below for the args to onRequestClose
          </ModalDialog>}
        <Button onClick={() => setModalIsOpen(true)} mb="m" mdxType="Button">
          Open Modal
        </Button>
        {onRequestCloseArgs && <>
            <Heading as="h5" variant="h5" mdxType="Heading">
              Args
            </Heading>
            <div>{JSON.stringify(onRequestCloseArgs)}</div>
          </>}
      </>;
      }}
    </Playground>
    <h3 {...{
      "id": "props"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">
  {[{
        name: 'onRequestClose',
        description: 'Function invoked when user tries to close modal',
        defaultValue: 'undefined',
        type: 'function',
        responsive: 'false'
      }, {
        name: 'showCloseButton',
        description: 'Close button shown if true',
        defaultValue: 'true',
        type: 'Boolean',
        responsive: 'false'
      }, ...COMMON]}
    </PropsTable>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;